import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { OneClickPaymentProvider } from '../../../../providers/order/one-click-payment.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickStandardLotProvider } from '../../../../providers/order/one-click-standard-lot.provider';
import { OneClickDeliveryMethodProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-method.provider';
import { OneClickLocationDisplayer } from '../../../../providers/order/one-click-multiple-jobsite-displayer.provider';
import { OneClickPlantsProvider } from '../../../../providers/order/one-click-plants.provider';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagjobsite',
    dataTIdValue: 'cmx-createoneclickorder-lblvaljobsite',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PointOfDelivery,
    label: 'views.one_click.pod',
    hidden: OneClickLocationDisplayer.HidePointOfDelivery,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-12 mb-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpointofdelivery',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpointofdelivery',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryMethod,
    text: OneClickDeliveryMethodProvider.TextPreview,
    label: 'views.one_click.delivery_method',
    containerClassNames: ['col-md-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagdeliverymethod',
    dataTIdValue: 'cmx-createoneclickorder-lblvaldeliverymethod',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    containerClassNames: ['col-md-6 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagproduct',
    dataTIdValue: 'cmx-createoneclickorder-lblvalproduct',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Quantity,
    text: OneClickStandardLotProvider,
    label: 'views.specifications.quantity',
    containerClassNames: ['col-md-4 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagquantity',
    dataTIdValue: 'cmx-createoneclickorder-lblvalquantity',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    text: OneClickPaymentProvider,
    label: 'views.one_click.payment_method',
    containerClassNames: ['col-md-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpayment',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpayment',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Plant,
    text: OneClickPlantsProvider,
    label: 'views.one_click.plant',
    containerClassNames: ['col-md-6 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagplant',
    dataTIdValue: 'cmx-createoneclickorder-lblvalplant',
  } as FieldLabelConfig,
];
